import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import LoginPage from './iap-admin/LoginPage';
import Dashboard from './iap-admin/Dashboard';
import ErrorBoundary from './iap-admin/ErrorBoundary';
import { trackPageView } from './services/applicationInsights';
import { AuthProvider, useAuth } from './auth/AuthProvider';
import OAuthCallback from './iap-admin/OAuthCallback.jsx';
import { getAccessToken } from './auth/tokenStorage';
import AppToaster from './iap-admin/shared/AppToaster';

// Component to track route changes
function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname, window.location.href, {
      route: location.pathname,
      search: location.search
    });
  }, [location]);

  return null;
}

// Redirect to login if not authenticated
function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();

  const hasStoredTokens = (() => {
    return !!getAccessToken();
  })();

  if (!isAuthenticated && !hasStoredTokens) {
    return <Navigate to="/" replace />;
  }

  return children;
}

// Redirect to dashboard if already authenticated
function GuestRoute({ children }) {
  const { isAuthenticated } = useAuth();

  const hasStoredTokens = (() => {
    return !!getAccessToken();
  })();

  if (isAuthenticated || hasStoredTokens) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

function App() {
  useEffect(() => {
    // Track initial page load
    trackPageView('App Start', window.location.href, {
      initialLoad: true,
      environment: process.env.REACT_APP_ENVIRONMENT
    });
  }, []);

  return (
    <ErrorBoundary>
      <AuthProvider>
        <Router>
          <AppToaster />
          <RouteTracker />
          <Routes>
            <Route path="/" element={<GuestRoute><LoginPage /></GuestRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/callback" element={<OAuthCallback />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;